import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

export default () => {
  const interactor = useLocalStore(() => ({
    focusApp() {
      Entities.App.setFocused(true);
    },

    unfocusApp() {
      Entities.App.setFocused(false);
    },
  }));

  return interactor;
};
